import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';
import { Box, Typography, TextField, Button, Link, Dialog, DialogTitle, DialogContent, DialogActions, Avatar } from '@mui/material';
import { useHistory } from 'react-router-dom';


function CaliforniaPropCommentsPage() {
  const { id } = useParams();
  const [calProp, setCalProp] = useState(null);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState('');
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');


  const [openDialog, setOpenDialog] = useState(false);
  const [voteType, setVoteType] = useState(null); // "Pass" | "No Pass"
  const [comment, setComment] = useState("");
  const [activePostId, setActivePostId] = useState(null);


  const [replyOpen, setReplyOpen] = useState(false);
  const [replyText, setReplyText] = useState("");
  const [activeCommentId, setActiveCommentId] = useState(null);


  // fetch california proposition info
  useEffect(() => {
       axios.get(`/CaliforniaProposition50`)
           .then(res => setCalProp(res.data))
           .catch(err => console.error("Error loading case", err));
   }, []);

   console.log(calProp);
  
  // Fetch comments
  useEffect(() => {
  axios.get(`/calProp/${id}/comments`)
      .then(res => setComments(res.data))
      .catch(err => console.error("Error loading comments", err));
  }, [id]);


  const handleSubmitComment = async () => {
      if (!newComment.trim()) return;


      try {
          const res = await axios.post(`/calProp/${id}/comment`, { text: newComment }); // NOTE: single 'comment'
          setComments(prev => [res.data, ...prev]);
          setNewComment('');
      } catch (err) {
          console.error("Error submitting comment", err);
      }
  };


  const toggleVote = async (calPropId) => {
      try {
          const res = await axios.post(`/calProp/${calPropId}/upvote`);
          const { upvotes, voted } = res.data;


          setCalProp(prevCase => ({
              ...prevCase,
              upvoteCount: upvotes,
              voted
          }));
      } catch (err) {
          console.error('Error toggling vote:', err);
      }
  };


  const handleSubmit = async () => {
      try {
          await axios.post('/api/govPosts', {
              title,
              content,
              topic: 'page2subpaged' // this allows you to filter it in Page2SubPageD
          });
          setOpen(false);
          setTitle('');
          setContent('');
          alert('Post created!');
      } catch (err) {
          console.error('Failed to create post', err);
      }
  };


  const toggleNo = async (calPropId) => {
       try {
           const res = await axios.post(`/calProp/${calPropId}/no`);
           const { upvotes, calPropVoted } = res.data;




           setCalProp(prevCalProp => ({
               ...prevCalProp,
               noCount: upvotes,
               calPropVoted,
           }));
       } catch (err) {
           console.error('Error toggling vote:', err);
       }
   };


   const toggleYes = async (calPropId) => {
       try {
           const res = await axios.post(`/calProp/${calPropId}/yes`);
           const { upvotes, calPropVoted} = res.data;


           //setCalProp(prev =>
           //    prev.map(calProp => calProp._id === calPropId ? { ...calProp, yesCount: upvotes, calPropVoted } : calProp)
           //);
          
           setCalProp(prevCalProp => ({
               ...prevCalProp,
               yesCount: upvotes,
               calPropVoted,
           }));
       } catch (err) {
           console.error('Error toggling vote:', err);
       }
   };




  const handleOpenDialog = (calPropId) => {
     setActivePostId(calPropId);
     setOpenDialog(true);
  };


  const handleSubmitVote = async () => {
      if (!voteType || !comment.trim() || !activePostId) {
          alert("Please choose vote type and enter a comment.");
          return;
      }


      try {
          const res = await axios.post(`/calProp/${activePostId}/comment`, { text: comment }); // NOTE: single 'comment'
          setComments(prev => [res.data, ...prev]);


          if (voteType === "Yes") {
              await toggleYes(activePostId);
          } else {
              await toggleNo(activePostId);
          }
          setOpenDialog(false);
          setComment("");
          setVoteType(null);
      } catch (err) {
          console.error(err);
      }
  };


  const toggleCommentVote = async (commentId) => {
      try {
              // hit backend endpoint that toggles a vote
              const res = await axios.post(`/calPropComments/${commentId}/upvote`);


              // update <posts> in react state so ui rerenders
              // setPosts(prev => ...) receives the previous array of posts and must return a new array
              // prev.map( p => { ... } )
              // iterate through every post p in old array
              // if p is the one user just voted on, return a new object with the fresh upvote info from server
              // otherwise, return p unchanged
          setComments((prev) =>
              prev.map((p) =>
                  p._id === commentId
                      ? {
                          ...p, // copy exisiting post fields
                          upvotes: res.data.upvotes, // updated count
                          voted:   res.data.voted // true or false that user voted
                      }
                      : p // all other posts unchanged
              )
          );
      } catch(err) {
          console.error("Vote error", err);
      }
  };


  const handleReplyOpen = (commentId) => {
      setActiveCommentId(commentId);
      setReplyOpen(true);
  };


  const handleReplyClose = () => {
      setReplyOpen(false);
      setReplyText("");
      setActiveCommentId(null);
  };


  const handleReplySubmit = async () => {
      if (!replyText.trim()) return;


      try {
      const res = await axios.post(`/calProp/comments/${activeCommentId}/replies`, {
          text: replyText
      });


      // Update state with new reply
      setComments(prev =>
          prev.map(c =>
          c._id === activeCommentId
              ? { ...c, replies: [...(c.replies || []), res.data] }
              : c
          )
      );


      handleReplyClose();
      } catch (err) {
      console.error("Reply error", err);
      }
  };
 
  //const scotusRespondentCount = scotusCase.respondentCount || 0;
  const calPropYesCount = calProp?.yesCount ?? 0;
  //console.log(scotusRespondentCount);
   const callPropNoCount = calProp?.noCount ?? 0;
  let votePercentage = 0;
  if (calPropYesCount > callPropNoCount) {
      votePercentage =calPropYesCount/(calPropYesCount+callPropNoCount)
  } else if (callPropNoCount > calPropYesCount) {
      votePercentage = callPropNoCount/(calPropYesCount+callPropNoCount)
  }


  let offset = 0;
  if (calPropYesCount > callPropNoCount) {
      offset = votePercentage * 50; // move right
  } else if (callPropNoCount > calPropYesCount) {
      offset = -votePercentage * 50; // move left
  }


  let tickColor = "blue"; // default at center
  if (offset > 0) {
      tickColor = "red"; // right side
  } else if (offset < 0) {
      tickColor = "red"; // left side
  }
 
   //const { id } = useParams();
  //return <h1>California Bill Comments for {id}</h1>;


  return(
      <div
         style={{
             padding: '20px',
             backgroundColor: '#FFFDF8',
             minHeight: '100vh',  // ensures it covers the full viewport height
             boxSizing: 'border-box', // ensures padding doesn't affect layout
         }}
     >




         <div style={{ width: '200px' }}></div>


         <Box
             display="flex"
             justifyContent="center"
             alignItems="center"
             gap={2}
             flexWrap="wrap"
             sx={{
                 mt: 4,
                 mb: 4,
             }}
                 >
                   <Button
                     variant="outlined"
                     sx={{
                         padding: "6px 12px",
                         borderColor: "#333333",
                         color: "#333333",    
                         backgroundColor: "transparent",
                         '&:hover': {
                             borderColor: "black",
                             color: "black",
                             backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                         },
                     }}
                     onClick={() => history.push('/page2/b/b1')}
                 >
                     Enacted Laws
                 </Button>
                 <Button
                     variant="outlined"
                     sx={{
                         padding: "6px 12px",
                         borderColor: "#333333",
                         color: "#333333",    
                         backgroundColor: "transparent",
                         '&:hover': {
                             borderColor: "black",
                             color: "black",
                             backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                         },
                     }}
                     onClick={() => history.push('/page2/b/b2')}
                 >
                     U.S. Congressional Bills
                 </Button>
                 <Button
                     variant="outlined"
                     sx={{
                         padding: "6px 12px",
                         borderColor: "#333333",
                         color: "#333333",    
                         backgroundColor: "transparent",
                         '&:hover': {
                             borderColor: "black",
                             color: "black",
                             backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                         },
                     }}
                     onClick={() => history.push('/page2/CaliforniaBills')}
                 >
                     California Legislature Bills
                 </Button>
                 <Button
                     variant="outlined"
                     sx={{
                         padding: "6px 12px",
                         borderColor: "#333333",
                         color: "#333333",    
                         backgroundColor: "transparent",
                         '&:hover': {
                             borderColor: "black",
                             color: "black",
                             backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                         },
                     }}
                     onClick={() => history.push(`/page2/CaliforniaPropositions`)}
                 >
                     State Propositions
                 </Button>
                 <Button
                     variant="outlined"
                     sx={{
                         padding: "6px 12px",
                         borderColor: "#333333",
                         color: "#333333",    
                         backgroundColor: "transparent",
                         '&:hover': {
                             borderColor: "black",
                             color: "black",
                             backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                         },
                     }}
                     onClick={() => setOpen(true)}
                 >
                     Propose
                 </Button>
          </Box>
         
         
          <Box
              p={2} // padding inside box
              my={2} // vertical margin between posts
              border="1px solid #ccc" // light grey border
              borderRadius="8px" // rounded corners
              sx={{
                  position: "relative",
                  maxWidth: 900, // limit width
                  mx: "auto", // center horizontally
                  my: 2, // vertical spacing between each post
              }}
          >
           <Button
                  onClick={(e) => {
                      e.stopPropagation();
                      joinVideoCall(bill._id)}
                  }
                  variant="outlined"
                  size="small"
                  sx={{
                      position: "absolute",
                      top: 8,
                      right: 8,
                      zIndex: 1
                  }}
              >
                  Join Voice Call
              </Button>




              <Typography
                  fontWeight="bold"
                  sx={{
                      wordBreak: "break-word",
                      pr: "140px",
                      mb: 1
                  }}
              >
                  {calProp?.propTitle}
              </Typography>




       <Typography
                 fontWeight="regular"
                 sx={{
                     wordBreak: "break-word",
                     pr: "140px",
                     mb: 1
                 }}
             >
                 {calProp?.propDescription}
              </Typography>
              <Box
                  display="flex"
                  justifyContent="center"
                  sx={{
                      mb: 2,
                      //my: 1
                  }}
              >
                  <Button
                      variant="outlined"
                      size="small"
                      onClick={() => handleOpenDialog(calProp._id)}
                      //sx={{ ml: 2.3 }}
                      //sx={{ mr: 2.3 }}
                      sx={{ mr: 1 }}
                  >
                      Vote
                  </Button>
              </Box>
              <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  sx={{ mb: 2 }}
                  >
                  <Typography variant="body2">No</Typography>




                  <Box
                      sx={{
                          position: "relative",
                          height: "2px",
                          backgroundColor: "#ccc",
                          width: "300px",
                          mx: 2
                      }}>


                          <Box sx={{
                              position: "absolute",
                              top: "-6px",
                              left: "50%",
                              transform: "translateX(-50%)",
                              width: "2px",
                              height: "14px",
                              backgroundColor: "black"
                          }} />
                    


                      <Box
                          sx={{
                              position: "absolute",
                              top: "-6px",
                              left: `calc(50% + ${offset}%)`,
                              transform: "translateX(-50%)",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center"
                          }}
                          >


                          <Box sx={{
                              width: "2px",
                              height: "14px",
                              backgroundColor: tickColor
                          }} />




                          <Typography
                              variant="caption"
                              sx={{ mt: "2px", fontSize: "0.7rem" }}
                          >
                              {(votePercentage * 100).toFixed(0)}%
                          </Typography>
                          </Box>
                      </Box>


                      <Typography variant="body2">Yes</Typography>
              </Box>


              <Link
             href={`/api/calProp/pdf/${calProp?.doc_id}`}
             target="_blank"
             rel="noopener noreferrer"
             onClick={(e) => e.stopPropagation()}
         >
             View Proposition
           </Link>


              <Box mt={2} display="flex" alignItems="center" gap={1}>
                  <Button
                      size="small"
                      variant={calProp?.voted ? "contained" : "outlined"}
                      onClick={() => toggleVote(calProp._id)}
                  >
                      ▲ {calProp?.voted ? "Unvote" : "Upvote"}
                  </Button>
                  <Typography variant="body2">{calProp?.upvoteCount} Visibility Upvotes | {calProp?.noCount} No Pass Votes | {calProp?.yesCount} Pass Votes</Typography>
              </Box>
          </Box>
         
         <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth>
             <DialogTitle>Cast Your Power Vote</DialogTitle>
             <DialogContent>
                 <Box display="flex" gap={2} mb={2}>
                     <Button
                       variant={voteType === "No" ? "contained" : "outlined"}
                       onClick={() => setVoteType("No")} 
                     >
                       No
                     </Button>
                     <Button
                         variant={voteType === "Yes" ? "contained" : "outlined"}
                         onClick={() => setVoteType("Yes")}
                     >
                         Yes
                     </Button>
                 </Box>
                 <TextField
                     fullWidth
                     multiline
                     rows={3}
                     placeholder="Explain your power vote (required)"
                     value={comment}
                     onChange={(e) => setComment(e.target.value)}
                 />
             </DialogContent>
             <DialogActions>
                 <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                 <Button
                     variant="outlined"
                     onClick={handleSubmitVote}
                     disabled={!comment || !voteType}
                 >
                     Submit Power Vote
                 </Button>
             </DialogActions>
         </Dialog>


          <Box
              p={2} // padding inside box
              my={2} // vertical margin between posts
              border="1px solid #ccc" // light grey border
              borderRadius="8px" // rounded corners
              sx={{
                  position: "relative",
                  maxWidth: 900, // limit width
                  mx: "auto", // center horizontally
                  my: 2, // vertical spacing between each post
              }}
          >
          <TextField
              fullWidth
              multiline
              rows={2}
              placeholder="Engage in intellectual discouse..."
              value={newComment}
              onChange={e => setNewComment(e.target.value)}
          />
          <Button variant="outlined" sx={{ mt: 1 }} onClick={handleSubmitComment}>
              Submit Comment
          </Button>
          </Box>




          {comments.length === 0 ? (
              <Typography>No comments yet.</Typography>
          ) : (
              comments.map((comment, i) => (
              <Box
                  p={2} // padding inside box
                  onClick={() => history.push(`/calProp/${id}/comments/${comment._id}`)}
                  my={2} // vertical margin between posts
                  border="1px solid #ccc" // light grey border
                  borderRadius="8px" // rounded corners
                  sx={{
                      position: "relative",
                      maxWidth: 900, // limit width
                      mx: "auto", // center horizontally
                      my: 2, // vertical spacing between each post
                      cursor: "pointer",
                      "&:hover": {
                          backgroundColor: "#f9f9f9"
                      }
                  }}
          >


                  <Box display="flex" alignItems="flex-start" gap={1}>
                              <Avatar
                                  src={comment.author?.profileImageUrl || '/default-avatar.jpg'}
                                  alt={`${comment.author?.first_name || ''} ${comment.author?.last_name || ''}`}
                                  sx={{ width: 62, height: 62 }}
                              />
                              <Box>
                                  <Typography variant="subtitle1" fontWeight="bold">
                                  {comment.author?.first_name && comment.author?.last_name
                                      ? `${comment.author.first_name} ${comment.author.last_name}`
                                      : 'Unknown Name'}
                                  </Typography>
                                  <Typography variant="body2" color="text.secondary">
                                  @{comment.author?.username || 'unknown'}
                                  </Typography>




                                  <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                                      {comment.text}
                                  </Typography>




                                  <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
                                      {`${new Date(comment.created_at).toLocaleString()}, ${comment.replies.length} ${comment.replies.length === 1 ? 'reply' : 'replies'}`}
                                      </Typography>




                              </Box>
                          </Box>


                          <Box mt={2} display="flex" alignItems="center" gap={1}>
                              <Button
                                  size="small"
                                  variant={comment.voted ? "contained" : "outlined"}
                                  onClick={(e) => {
                                      e.stopPropagation();
                                      toggleCommentVote(comment._id)}
                                  }
                              >
                                  ▲ {comment.voted ? "Unvote" : "Upvote"}
                              </Button>
                              <Typography variant="body2">{comment.upvotes} upvotes</Typography>
                          </Box>


              </Box>
              ))
          )}
          <Dialog open={replyOpen} onClose={handleReplyClose}>
          <DialogTitle>Reply to Comment</DialogTitle>
          <DialogContent>
              <TextField
              autoFocus
              fullWidth
              multiline
              minRows={3}
              value={replyText}
              onChange={(e) => setReplyText(e.target.value)}
              placeholder="Write your reply..."
              />
          </DialogContent>
          <DialogActions>
              <Button onClick={handleReplyClose}>Cancel</Button>
              <Button onClick={handleReplySubmit} variant="contained">
              Post Reply
              </Button>
          </DialogActions>
          </Dialog>


          </div>
  );
}


export default CaliforniaPropCommentsPage;
